import { render } from "./Index.vue?vue&type=template&id=5cc3d152&bindings={\"users\":\"props\",\"tenants\":\"props\",\"filters\":\"props\",\"flash\":\"props\",\"selectedRecord\":\"data\",\"search\":\"options\",\"showDeleteConfirmationModal\":\"options\",\"deleteRecord\":\"options\",\"navigateToEdit\":\"options\"}"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "5cc3d152"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cc3d152')) {
    api.reload('5cc3d152', script)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=5cc3d152&bindings={\"users\":\"props\",\"tenants\":\"props\",\"filters\":\"props\",\"flash\":\"props\",\"selectedRecord\":\"data\",\"search\":\"options\",\"showDeleteConfirmationModal\":\"options\",\"deleteRecord\":\"options\",\"navigateToEdit\":\"options\"}", () => {
    api.rerender('5cc3d152', render)
  })

}

script.__file = "resources/js/Pages/Users/Index.vue"

export default script